import { useLocationQuery } from "../../hooks";

export interface IProps<Q extends string, V extends string> {
    query: Q;
    children: (props: IRenderProps<V>) => JSX.Element;
}

export interface IRenderProps<V extends string> {
    value: V | null;
    setValue: (value: V | null) => void;
}

const QueryField = <Q extends string, V extends string = string>({ query, children }: IProps<Q, V>): JSX.Element => {
    const locationQuery = useLocationQuery<Q>();
    const currentValue = locationQuery.get<V>(query);

    return children({
        value: currentValue,
        setValue: newValue => (newValue === null ? locationQuery.del(query) : locationQuery.set(query, newValue))
    });
};

export default QueryField;
